/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-vars */
/* eslint-disable no-debugger */
/* eslint-disable import/order */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';

import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
// import DetailIcon from '@mui/icons-material/Details';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';
import ListIcon from '@mui/icons-material/List';
import SearchOutlined from '@mui/icons-material/SearchOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import {
  Container,
  Grid,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  InputAdornment,
  Chip,
  Stack,
  Pagination,
  Box,
  Divider,
  Tooltip,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import ToggleButton from '@mui/material/ToggleButton';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';
// eslint-disable-next-line import/order
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { connect } from 'react-redux';
// import { Breadcrumbs } from 'wae_rwlb_reactlibrary';

import { styles } from './styles';
import './styles.css';
import {
  addToCart,
  addMultipleItemToCart,
  getItemListData,
  addToFavorite,
  removeFavouriteItem,
  getFavouriteData,
  getMaterialGroupTableData,
  addRemoveFavourites,
  getSortedList,
  saveItemList,
  // getAllProductsData,
  resetTableData,
  updateTableData,
} from '../../../actions';
import { Table, Filter, ProductCard, Breadcrumb } from '../../../components';
import { COLOR } from '../../../helpers/colors';
import { breadcrumbNameMap } from '../../../helpers/config';
import {
  downloadExcel,
  formatAmount,
  formatedText,
  roundToTwoDecimals,
} from '../../../helpers/functions';
import i18n from '../../../helpers/i18nMain';
import FilterPlaceholder from '../FilterPlaceholder';
import ListPlaceholder from '../ListPlaceholder';
import TogglePlaceholder from '../TogglePlaceholder/index';

import CircularProgress from '@mui/material/CircularProgress';
import { LoadingButton } from '@mui/lab';
import { Add, CachedOutlined, PlusOne } from '@mui/icons-material';

const productColumnsConfig = (
  t,
  handleAddToCartClick,
  handleFavourite,
  favouriteItems,
  isFavourateIconLoading,
  selectedMaterial,
  removeItemFromTable
) => [
  {
    field: 'col1',
    headerName: t('productScreenTranslations:MATERIAL'),
    key: 'Material',
    minWidth: 150,
    inputType: 'TextField',
  },
  {
    field: 'col9',
    headerName: 'Material Group',
    key: 'MaterialGroupName',
    minWidth: 150,
    // hideFromHeader: true,
    inputType: 'MultiSelect',
  },
  {
    field: 'col12',
    headerName: 'Superseeded Part No',
    key: 'ConcatSuperMaterials',
    minWidth: 150,
    inputType: 'TextField',
    // renderCell: params2 => {
    //   return <Typography>{params2.row.col12 !== '' ? params2.row.col12 : '-'}</Typography>;
    // },
    renderCell: params2 => {
      return (
        <Tooltip title={params2.row.col12}>
          <Typography nowrap={false}>
            {params2.row.col12 !== '' ? formatedText(params2.row.col12) : '-'}
          </Typography>
        </Tooltip>
      );
    },
  },

  {
    field: 'col10',
    headerName: 'Quantity',
    key: 'Quantity',
    // minWidth: 150,
    inputType: 'TextField',
  },
  {
    field: 'col2',
    headerName: t('productScreenTranslations:GROSS_WEIGHT'),
    key: 'MaterialGrossWeight',
    minWidth: 150,
    flex: 1,
    inputType: 'Float',
  },
  {
    field: 'col3',
    headerName: 'Material Name',
    key: 'MaterialName',
    minWidth: 150,
    flex: 1,
    inputType: 'TextField',
    renderCell: params2 => {
      return (
        <Tooltip title={params2.row.col3}>
          <Typography nowrap={false}>
            {params2.row.col3 !== '' ? formatedText(params2.row.col3) : '-'}
          </Typography>
        </Tooltip>
      );
    },
  },
  {
    field: 'col4',
    headerName: t('productScreenTranslations:STOCK_QUANTITY'),
    key: 'StockQuantity',
    minWidth: 150,
    flex: 1,
    inputType: 'Float',
    hideFromFilter: true,
  },
  {
    field: 'col5',
    headerName: 'Currency',
    key: 'SalesPriceUnit',
    // minWidth: 150,
    // flex: 1,
    inputType: 'TextField',
    hideFromFilter: true,
    hideFromHeader: true,
  },
  {
    field: 'col8',
    headerName: 'Stock Quantity UOM',
    key: 'StockQuantityUOM',
    // minWidth: 150,
    // flex: 1,
    hide: true,
    hideFromFilter: true,
    inputType: 'TextField',
  },
  {
    field: 'col6',
    headerName: 'Price',
    key: 'SalesPrice',
    minWidth: 150,
    flex: 1,
    inputType: 'Float',
    hideFromFilter: true,
    renderCell: params2 => {
      return (
        <Typography>
          {formatAmount('en-AE', params2.value, params2.getValue(params2.id, 'col5'))}
        </Typography>
      );
    },
  },
  {
    field: 'col13',
    headerName: 'Tax',
    key: 'Tax',
    minWidth: 150,
    flex: 1,
    inputType: 'Float',
    hideFromFilter: true,
    renderCell: params2 => {
      return (
        <Typography>
          {formatAmount('en-AE', params2.value, params2.getValue(params2.id, 'col5'))}
        </Typography>
      );
    },
  },
  {
    field: 'col11',
    headerName: 'Net Value',
    // key: 'SalesPrice',
    minWidth: 150,
    flex: 1,
    inputType: 'Float',
    hideFromFilter: true,
    renderCell: params2 => {
      return (
        <Typography>
          {formatAmount(
            'en-AE',
            (roundToTwoDecimals(params2.row.col6) + roundToTwoDecimals(params2.row.col13)) *
              roundToTwoDecimals(params2.row.col10),
            params2.getValue(params2.id, 'col5') !== undefined
              ? params2.getValue(params2.id, 'col5')
              : ''
          )}
        </Typography>
      );
    },
  },

  {
    field: 'col7',
    headerName: 'Actions',
    minWidth: 150,
    flex: 1,
    hideFromFilter: true,
    renderCell: ({ row }) => {
      const isStockAndPriceUnavailable =
        row.col4 === 0 ||
        row.col4 === undefined ||
        roundToTwoDecimals(row.col6) === 0 ||
        row.col6 === undefined;

      const isFavorite = favouriteItems.some(item => item.Material === row.col1);
      const favTitle = isFavorite
        ? t('productScreenTranslations:REMOVE_FROM_FAV')
        : t('productScreenTranslations:ADD_TO_FAV');
      const FavIcon = isFavorite ? FavoriteOutlinedIcon : FavoriteBorderOutlinedIcon;

      const isSelectedMaterial = selectedMaterial === row.col1;

      return (
        <Stack direction="row" justifyContent="space-around">
          <IconButton
            onClick={() => handleAddToCartClick(row)}
            disabled={isStockAndPriceUnavailable}
          >
            <ShoppingCartOutlinedIcon style={{ width: '16px', height: '16px' }} />
          </IconButton>
          <IconButton
            onClick={() => handleFavourite(row, isFavorite)}
            title={favTitle}
            disabled={isStockAndPriceUnavailable}
          >
            {isSelectedMaterial && isFavourateIconLoading ? (
              <CircularProgress size={18} />
            ) : (
              <>
                {isFavorite ? (
                  <FavIcon style={{ color: 'red', width: '16px', height: '16px' }} />
                ) : (
                  <FavIcon style={{ color: 'currentColor', width: '16px', height: '16px' }} />
                )}
              </>
            )}
          </IconButton>
          <IconButton
            onClick={() => removeItemFromTable(row)}
            // disabled={isStockAndPriceUnavailable}
          >
            <CloseOutlined style={{ width: '16px', height: '16px' }} />
          </IconButton>
        </Stack>
      );
    },
  },
];
const max = 100;
const min = 1;
const searchTemplateData = [
  {
    label: 'Material',
    value: '',
    type: 'text',
  },
  {
    label: 'Quantity',
    value: '',
    type: 'number',
  },
];
const searchFieldItem = {
  id: Math.floor(Math.random() * (max - min)) + min,
  data: searchTemplateData,
};

class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortOrder: 'Low - High Price',
      searchTerm: '',
      searchSubmitted: false,
      searchKey: '',
      filters: [],
      page: 1,
      viewMode: 'details',
      page1: 0,
      rowsPerPage: 20,
      filteredData: [],
      filterField: '',
      showPriceFilter: false,
      filterConfigData: [
        {
          id: 'MaterialGroup',
          type: 'Checkbox',
          label: i18n.t('productScreenTranslations:MATERIAL_GROUP'),
          isMultiSelect: true,
          dataKey: 'MaterialGroup',
          filterFunction: (MaterialGroup, MaterialName) => ({
            MaterialGroup,
            MaterialName,
          }),
          config: {
            data: [],
          },
        },
      ],
      selectedMaterial: '',
      showDateFilter: false,
      showMultiFilter: false,
      multiSelectData: [],
      selectedRows: [],
      searchFields: [searchFieldItem],
      searchFieldsData: [],
    };
  }

  async componentDidMount() {
    try {
      // const field = this.state.viewMode === 'list' ? 'itemList' : 'itemTableList';
      // await this.props.getItemListData(0, this.props.enqueueSnackbar,);
      if (this.state.viewMode === 'list') {
        await this.props.getItemListData(0, this.props.enqueueSnackbar, () => {}, '');
      }
      await this.props.getMaterialGroupTableData();
      this.loadData();
      this.props.updateTableData([]);

      this.setState({ filteredData: [] });
    } catch (err) {
      console.log(err);
    }
  }

  handlePageChange = value => {
    this.setState({ page: value });
  };

  handleChange = async (event, value) => {
    try {
      const { filterConfigData, searchKey } = this.state;
      const skip = (value - 1) * 20;
      const { data } = filterConfigData[0].config;
      const materialGroupData = data.filter(d => d.checked === true);
      const filterStr = this.returnFilterStr(materialGroupData, searchKey);
      await this.props.getItemListData(
        skip,
        this.props.enqueueSnackbar,
        () => this.handlePageChange(value),
        filterStr
      );
      window.scrollTo(0, 0);
    } catch (err) {
      console.log(err);
    }
  };

  loadData = () => {
    try {
      const { materialGroupDataArr } = this.props.product;

      if (materialGroupDataArr !== null && materialGroupDataArr.length > 0) {
        const dfilterConfig = this.state.filterConfigData.map(f => {
          return {
            ...f,
            config: { data: materialGroupDataArr },
          };
        });
        this.setState(prevState => ({
          ...prevState,
          filterConfigData: dfilterConfig,
          multiSelectData: materialGroupDataArr,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  resetSearchFilter = async () => {
    try {
      const { filterConfigData } = this.state;
      this.setState({
        searchTerm: '',
        searchSubmitted: false,
        searchKey: '',
        page: 1,
      });
      const searchKey = '';
      const { data } = filterConfigData[0].config;
      const materialGroupData = data.filter(d => d.checked === true);
      const filterStr = this.returnFilterStr(materialGroupData, searchKey);
      await this.props.getItemListData(0, this.props.enqueueSnackbar, () => {}, filterStr);
    } catch (error) {
      console.log(error);
    }
  };

  removeItemFromTable = i => {
    const { t, product } = this.props;
    const { filteredData } = this.state;
    try {
      const { itemTableList } = product;
      const data = itemTableList.filter(d => d.Material !== i.col1);
      const fData = filteredData.filter(d => d.col1 !== i.col1);
      this.props.updateTableData(data);
      this.setState({ filteredData: fData });
      this.props.enqueueSnackbar('Removed from the Table', {
        variant: 'success',
      });
    } catch (err) {
      this.props.enqueueSnackbar(t('productScreenTranslations:SOMETHING_WENT_WRONG'), {
        variant: 'error',
      });
      console.log(err);
    }
  };

  handleAddToCartClick = i => {
    const { t } = this.props;
    try {
      let Material;
      let ConditionQuantity;
      let SalesPriceUnit;
      let SalesPrice;
      let MaterialName;
      let MaterialGrossWeight;
      let StockQuantityUOM;
      let StockQuantity;
      let Tax;

      if (i.Material !== undefined) {
        ({
          Material,
          ConditionQuantity,
          SalesPriceUnit,
          SalesPrice,
          MaterialName,
          MaterialGrossWeight,
          StockQuantityUOM,
          StockQuantity,
          Tax,
        } = i);
      } else {
        ({
          col1: Material,
          col10: ConditionQuantity,
          col5: SalesPriceUnit,
          col6: SalesPrice,
          col3: MaterialName,
          col2: MaterialGrossWeight,
          col10: StockQuantity,
          col8: StockQuantityUOM,
          col13: Tax,
        } = i);
      }

      const td = {
        Material,
        qty: parseInt(ConditionQuantity, 10),
        MaterialName,
        Price: SalesPrice,
        Currency: SalesPriceUnit,
        ConditionQuantity,
        MaterialGrossWeight,
        available: true,
        StockQuantityUOM,
        StockQuantity,
        Tax,
      };

      this.props.addToCart(td);
      this.props.enqueueSnackbar(t('productScreenTranslations:SUCC_ADDED_TO_THE_CART'), {
        variant: 'success',
      });
    } catch (err) {
      this.props.enqueueSnackbar(t('productScreenTranslations:SOMETHING_WENT_WRONG'), {
        variant: 'error',
      });
      console.log(err);
    }
  };

  handleAddToCart = () => {
    let msg = '';
    try {
      const { product } = this.props;
      const { itemTableList } = product;
      const { selectedRows } = this.state;
      const cartList = [];
      const selectedList = [];

      selectedRows.forEach(g => {
        selectedList.push(itemTableList[g].Material);
      });
      selectedList.forEach(sF => {
        const tD = itemTableList.find(f => f.Material === sF && f.SalesPrice && f.StockQuantity);
        if (tD !== undefined) {
          const res = {
            Material: tD.Material,
            qty: parseInt(tD.Quantity, 10),
            MaterialName: tD.MaterialName,
            Price: tD.SalesPrice,
            Currency: tD.SalesPriceUnit,
            ConditionQuantity: tD.ConditionQuantity,
            MaterialGrossWeight: tD.MaterialGrossWeight,
            available: true,
            StockQuantityUOM: tD.StockQuantityUOM,
            StockQuantity: tD.StockQuantity,
            Tax: tD.Tax,
          };
          cartList.push(res);
          msg = i18n.t('productScreenTranslations:SUCC_ADDED_TO_THE_CART');
        } else {
          msg = i18n.t('productScreenTranslations:SOMETHING_WENT_WRONG');
        }
      });
      if (cartList.length > 0) {
        this.props.addMultipleItemToCart(cartList);
        this.props.enqueueSnackbar(msg, {
          variant: 'success',
        });
      }

      if (cartList.length === 0) {
        this.props.enqueueSnackbar(msg, {
          variant: 'error',
        });
      }
      this.setState({ selectedRows: [] });
    } catch (err) {
      this.props.enqueueSnackbar(msg, {
        variant: 'error',
      });
    }
  };

  handleAddMultipleItemToCart = () => {
    const { t, product } = this.props;
    const { itemList } = product;
    try {
      const selectedItems = [];
      itemList.forEach(m => {
        if (m.checked) {
          const {
            Material,
            MaterialName,
            MaterialGrossWeight,
            ConditionQuantity,
            SalesPrice,
            SalesPriceUnit,
            StockQuantityUOM,
            StockQuantity,
            Tax,
          } = m;

          const res = {
            Material,
            MaterialName,
            qty: parseInt(ConditionQuantity, 10),
            Price: SalesPrice,
            Currency: SalesPriceUnit,
            ConditionQuantity,
            MaterialGrossWeight,
            available: true,
            StockQuantityUOM,
            StockQuantity,
            Tax,
          };
          selectedItems.push(res);
        }
      });
      if (selectedItems.length > 0) {
        this.props.addMultipleItemToCart(selectedItems);
        const list = itemList.map(m => ({ ...m, checked: false }));
        this.props.saveItemList(list);

        this.props.enqueueSnackbar(t('productScreenTranslations:SUCC_ADDED_TO_THE_CART'), {
          variant: 'success',
        });
      }
    } catch (err) {
      this.props.enqueueSnackbar(t('productScreenTranslations:SOMETHING_WENT_WRONG'), {
        variant: 'error',
      });
      console.log(err);
    }
  };

  sortList = value => {
    try {
      const { itemList } = this.props.product;
      const list = this.getSortedListByOrder(itemList, value);
      this.setState({ sortOrder: value });
      this.props.saveItemList(list);
    } catch (err) {
      console.log(err);
    }
  };

  handleSelection = i => {
    const { itemList } = this.props.product;
    const nItemList = itemList.map(m =>
      m.Material === i.Material ? { ...m, checked: !m.checked } : m
    );
    this.props.saveItemList(nItemList);
  };

  updateFavourite = async (i, Material, addDelete) => {
    const { itemList } = this.props.product;
    await this.props.getFavouriteData(this.props.enqueueSnackbar, addDelete);
    const mList = itemList.map(m => {
      return m.Material === Material ? { ...m, favourite: addDelete === '1' } : m;
    });
    this.props.saveItemList(mList);
  };

  handleFavourite = (i, isFavorite) => {
    try {
      const { selectedSalesOrgData } = this.props.auth;
      const { ItemProp } = selectedSalesOrgData;
      let Material;
      let MaterialBaseUnit;
      if (i.Material !== undefined && i.MaterialBaseUnit !== undefined) {
        Material = i.Material;
        MaterialBaseUnit = i.MaterialBaseUnit;
      } else {
        Material = i.col1;
        MaterialBaseUnit = i.col8;
      }

      this.setState({ selectedMaterial: Material });

      if (!i.favourite && !isFavorite) {
        const data = {
          NavMain: [
            {
              SalesDoucment: ItemProp,
              AddDelete: '1',
            },
          ],
          NavItems: [
            {
              Matnr: Material,
              Qty: '1',
              Uom: MaterialBaseUnit,
            },
          ],
        };
        this.props.addRemoveFavourites(
          data,
          this.props.enqueueSnackbar,
          this.updateFavourite,
          Material
        );
      } else if (isFavorite === true) {
        const { favouriteItems } = this.props.favourite;
        const m = favouriteItems.find(f => f.Material === i.col1);
        const data = {
          NavMain: [
            {
              SalesDoucment: ItemProp,
              AddDelete: '2',
            },
          ],
          NavItems: [
            {
              Posnr: m.SalesDocumentItem,
            },
          ],
        };
        this.props.addRemoveFavourites(
          data,
          this.props.enqueueSnackbar,
          this.updateFavourite,
          Material
        );
      } else {
        const { favouriteItems } = this.props.favourite;
        const m = favouriteItems.find(f => f.Material === i.Material);
        const data = {
          NavMain: [
            {
              SalesDoucment: ItemProp,
              AddDelete: '2',
            },
          ],
          NavItems: [
            {
              Posnr: m.SalesDocumentItem,
            },
          ],
        };
        this.props.addRemoveFavourites(
          data,
          this.props.enqueueSnackbar,
          this.updateFavourite,
          Material
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  handleItemClick = (params, event) => {
    const { favourite } = this.props;
    const { isFavourateIconLoading } = favourite;
    event.stopPropagation();
    if (params.field !== 'col7' && params.field !== '__check__' && !isFavourateIconLoading) {
      this.props.history.push(`/products/${params.row.col1}`);
    }
  };

  handleSearchSubmit = async () => {
    try {
      const { searchTerm, filterConfigData } = this.state;
      this.setState({
        searchKey: searchTerm,
      });
      let filterStr = '';

      const { data } = filterConfigData[0].config;
      const materialGroupData = data.filter(d => d.checked === true);
      if (materialGroupData.length > 0) {
        const materialGroupFilterArr = [];
        let materialGroupFilter = '';
        materialGroupData.forEach(m => {
          materialGroupFilterArr.push(`MaterialGroup eq '${m.MaterialGroup}'`);
        });
        if (materialGroupFilterArr.length > 0) {
          materialGroupFilter = materialGroupFilterArr.join(' or ');
        }
        filterStr = materialGroupFilter;
      }
      if (searchTerm !== '') {
        const searchFilter = `Material eq '${searchTerm}' or substringof('${searchTerm}', Material) eq true or  MaterialName eq '${searchTerm}' or substringof('${searchTerm}', MaterialName) eq true`;
        if (filterStr !== '') {
          filterStr = `(${filterStr}) and (${searchFilter})`;
        } else {
          filterStr = searchFilter;
        }
      }
      if (filterStr !== '') {
        await this.props.getItemListData(0, this.props.enqueueSnackbar, () => {}, filterStr);
      } else {
        await this.props.getItemListData(0, this.props.enqueueSnackbar, () => {});
      }
      this.setState({
        searchTerm: '',
        searchSubmitted: true,
        page: 1,
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  body = b => {
    const { t } = this.props;
    const cValues = b || { StockQuantity: undefined, StockQuantityUOM: undefined };

    const product = [
      { label: t('productScreenTranslations:MATERIAL'), value: b.Material },
      {
        label: t('productScreenTranslations:GROSS_WEIGHT'),
        value: `${b.MaterialGrossWeight} ${b.MaterialWeightUnit}`,
      },
      {
        label: t('productScreenTranslations:STOCK_QUANTITY'),
        value:
          cValues.StockQuantity && cValues.StockQuantityUOM
            ? `${cValues.StockQuantity} ${cValues.StockQuantityUOM}`
            : '-',
      },
    ];
    return product.map((p, index) => (
      <Grid key={index.toString()} container item direction="row" xs={5} md={5}>
        <Typography sx={{ fontSize: 13 }}>
          {p.label}:<span style={{ fontSize: 12, fontWeight: 'bold' }}> {p.value}</span>
        </Typography>
      </Grid>
    ));
  };

  titleRight = r => {
    const { t } = this.props;
    const cValues = r || { SalesPrice: undefined, SalesPriceUnit: undefined };
    return (
      <Grid container flexDirection="column" columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12}>
          <Typography
            sx={{ fontSize: 10, color: COLOR.subTitleColor, paddingTop: 0.5, fontWeight: 400 }}
          >
            {t('productScreenTranslations:SELLING_PRICE')}
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ marginTop: -0.2 }}>
          <Typography
            sx={{ fontSize: 16, fontWeight: 600, textAlign: 'center', color: COLOR.titleColor }}
          >
            {formatAmount('en-AE', cValues.SalesPrice, cValues.SalesPriceUnit)}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  getSortedListByOrder = (list, value) => {
    let sortOrder;
    if (value === 'Low - High Price') {
      sortOrder = 'asc';
    }
    if (value === 'High - Low Price') {
      sortOrder = 'desc';
    }
    return getSortedList(list, sortOrder);
  };

  returnCount = list => {
    let count = 0;
    if (list !== null) {
      list.forEach(m => {
        if (m.checked) {
          count += 1;
        }
      });
    }
    return count;
  };

  returnFilterStr = (materialGroupData, searchKey) => {
    let filterStr = '';
    if (materialGroupData.length > 0) {
      const materialGroupFilterArr = [];
      materialGroupData.forEach(m => {
        materialGroupFilterArr.push(`MaterialGroup eq '${m.MaterialGroup}'`);
      });
      if (materialGroupFilterArr.length > 0) {
        filterStr = materialGroupFilterArr.join(' or ');
      }
    }
    if (searchKey !== '') {
      const searchFilter = `Material eq '${searchKey}' or substringof('${searchKey}', Material) eq true or  MaterialName eq '${searchKey}' or substringof('${searchKey}', MaterialName) eq true`;
      if (filterStr !== '') {
        filterStr = `(${filterStr}) and (${searchFilter})`;
      } else {
        filterStr = searchFilter;
      }
    }
    return filterStr;
  };

  saveFilter = async filters => {
    try {
      const { searchKey } = this.state;
      const materialGroupData =
        filters.length > 0 ? filters[0].value.map(v => ({ MaterialGroup: v })) : [];
      const filterStr = this.returnFilterStr(materialGroupData, searchKey);
      await this.props.getItemListData(0, this.props.enqueueSnackbar, () => {}, filterStr);
      this.setState({ filters, page: 1 });
    } catch (e) {
      console.log(e);
    }
  };

  clearFilterComponent = () => {
    try {
      const { searchKey } = this.state;
      this.setState({ filters: [], page: 1 });
      const materialGroupData = [];
      const filterStr = this.returnFilterStr(materialGroupData, searchKey);
      this.props.getItemListData(0, this.props.enqueueSnackbar, () => {}, filterStr);
    } catch (error) {
      console.log(error);
    }
  };

  onChangeSearchInput = e => {
    this.setState({ searchTerm: e.target.value });
  };

  onSearchKeyPress = ev => {
    if (ev.key === 'Enter') {
      this.handleSearchSubmit(ev);
      ev.preventDefault();
    }
  };

  onChangeSortBySelectInput = e => this.sortList(e.target.value);

  renderList = updatedList => {
    const { t, favourite } = this.props;
    const { selectedMaterial } = this.state;
    const { isFavourateIconLoading } = favourite;

    return updatedList.map((m, index) => {
      const isStockAndPriceAvailable =
        m.SalesPrice === 0 ||
        m.SalesPrice === undefined ||
        m.StockQuantity === 0 ||
        m.StockQuantity === undefined;

      return (
        <ProductCard
          product={m}
          key={index.toString()}
          title={m.MaterialName}
          titleRight={this.titleRight(m)}
          body={this.body(m)}
          navigationUrl={m.Material !== '' ? `/products/${m.Material}` : ''}
          isSelected={m.checked}
          icons={[
            {
              icon: m.favourite === true ? FavoriteOutlinedIcon : FavoriteBorderOutlinedIcon,
              title: m.favourite
                ? t('productScreenTranslations:REMOVE_FROM_FAV')
                : t('productScreenTranslations:ADD_TO_FAV'),
              onClick: () => this.handleFavourite(m),
              color: m.favourite === true ? COLOR.titleColor : COLOR.blackColor,
              disable: isStockAndPriceAvailable,
              showLoader: isFavourateIconLoading,
              selectedMaterial,
            },
            {
              icon: ShoppingCartOutlinedIcon,
              title: t('productScreenTranslations:TO_CART'),
              onClick: () => this.handleAddToCartClick(m),
              color: COLOR.blackColor,
              disable: isStockAndPriceAvailable,
              showLoader: false,
              selectedMaterial,
            },
            {
              icon: CheckOutlinedIcon,
              title: t('productScreenTranslations:SELECT'),
              onClick: () => this.handleSelection(m),
              color: COLOR.blackColor,
              disable: isStockAndPriceAvailable,
              showLoader: false,
              selectedMaterial,
            },
          ]}
          image=""
        />
      );
    });
  };

  handleViewModeChange = async (event, newViewMode) => {
    if (newViewMode !== null) {
      this.setState({ viewMode: newViewMode });
      if (newViewMode === 'list') {
        await this.props.getItemListData(0, this.props.enqueueSnackbar);
      }
    }
  };

  handleChangeTog = async (e, value) => {
    try {
      const {
        rowsPerPage,
        searchTerm,
        showPriceFilter,
        showDateFilter,
        showMultiFilter,
        filterField,
        searchFieldsData,
      } = this.state;
      const { t } = this.props;
      const skip = value * rowsPerPage;
      this.setState({ page1: value });
      const columnsConfigData = productColumnsConfig(t);
      const selectedCol = columnsConfigData.find(c => c.field === filterField);
      let filterStr = '';
      const field = 'itemTableList';
      if (searchTerm !== '' && selectedCol !== undefined) {
        filterStr =
          showDateFilter || showPriceFilter
            ? `${selectedCol.key} eq ${searchTerm}`
            : `${selectedCol.key} eq '${searchTerm}' or substringof('${searchTerm}', ${selectedCol.key}) eq true`;
        if (showMultiFilter) {
          filterStr = `${searchTerm}`;
        }
      }
      const searchFieldFilter = this.returnFilterSearch();
      if (searchFieldFilter !== '') {
        filterStr =
          filterStr === '' ? searchFieldFilter : `(${filterStr}) or (${searchFieldFilter})`;
      }
      if (filterStr !== '') {
        await this.props.getItemListData(
          skip,
          this.props.enqueueSnackbar,
          () => {},
          filterStr,
          field,
          searchFieldsData
        );
      } else {
        await this.props.getItemListData(
          skip,
          this.props.enqueueSnackbar,
          () => {},
          filterStr,
          field
        );
      }
      window.scrollTo(0, 0);
    } catch (err) {
      console.log(err);
    }
  };

  saveFilterData = async (fData, selectedCol, searchTerm = '') => {
    const { showPriceFilter, showDateFilter, showMultiFilter } = this.state;
    let filterStr = '';
    if (searchTerm !== '') {
      filterStr =
        showDateFilter || showPriceFilter
          ? `${selectedCol.key} eq ${searchTerm}`
          : `${selectedCol.key} eq '${searchTerm}' or substringof('${searchTerm}', ${selectedCol.key}) eq true`;
      if (showMultiFilter) {
        filterStr = `${searchTerm}`;
      }
    }
    if (filterStr !== '') {
      this.props.getItemListData(0, this.props.enqueueSnackbar, () => {}, filterStr);
      this.setState({ page1: 0 });
    }
    this.setState({ filteredData: fData });
  };

  loadToggleData = () => {
    const { itemTableList } = this.props.product;
    // const filterStr = this.returnFilterSearch();
    const Data = itemTableList.map(r => ({
      Material: r.Material,
      'Material Group': r.MaterialGroupName,
      'SuperSeeded Part No': r.ConcatSuperMaterials,
      Quantity: r.Quantity,
      'Gross Weight': r.MaterialGrossWeight,
      'Material Name': r.MaterialName,
      'Stock Quantity': r.StockQuantity,
      Price: r.SalesPrice,
      Tax: r.Tax,
      'Net Value':
        isNaN(roundToTwoDecimals(r.Tax)) ||
        isNaN(roundToTwoDecimals(r.SalesPrice)) ||
        isNaN(roundToTwoDecimals(r.Quantity))
          ? ''
          : (roundToTwoDecimals(r.Tax) + roundToTwoDecimals(r.SalesPrice)) *
            roundToTwoDecimals(r.Quantity),
    }));

    downloadExcel(Data, 'AllProducts.xlsx', 'Products');
    // this.props.getAllProductsData(0, this.props.enqueueSnackbar, filterStr);
  };

  clearFilter = () => {
    const { materialGroupDataArr } = this.props.product;
    this.props.getItemListData(0, this.props.enqueueSnackbar, () => {});
    this.setState({
      searchTerm: '',
      filterField: '',
      selectedDate: null,
      showDateFilter: false,
      showMultiFilter: false,
      page1: 0,
      multiSelectData: materialGroupDataArr,
    });
  };

  handleMultiSelection = item => {
    const { multiSelectData, searchKey } = this.state;
    const data = multiSelectData.map(m => ({
      ...m,
      checked: item.id === m.id ? !m.checked : m.checked,
    }));
    const materialGroupData = data.filter(d => d.checked === true);
    const filterStr = this.returnFilterStr(materialGroupData, searchKey);
    this.setState({ multiSelectData: data, searchTerm: filterStr });
  };

  saveFilterFields = data => {
    this.setState(prevState => ({
      ...prevState,
      ...data,
    }));
  };

  handleAddSearchFields = (index, id, type = 'add') => {
    const { searchFields } = this.state;
    const isLast = index + 1 === searchFields.length;
    if (type === 'add') {
      const sFields = searchFields;
      sFields.push({
        id: Math.floor(Math.random() * (max - min)) + min,
        data: searchTemplateData,
      });
      this.setState({ searchFields: sFields });
    } else {
      const sFields = searchFields.filter(s => s.id !== id);
      this.setState({ searchFields: sFields });
    }
  };

  onChangeSearchFields = (event, row, field) => {
    const { searchFields } = this.state;
    const dItem = searchFields.find(s => s.id === row.id);
    const data = dItem.data.map(d => ({
      ...d,
      value: d.label === field ? event.target.value : d.value,
    }));
    const sData = searchFields.map(s => ({ ...s, data: s.id === row.id ? data : s.data }));
    this.setState({ searchFields: sData });
  };

  returnFilterSearch = () => {
    const { searchFields } = this.state;
    const Materials = [];
    searchFields.forEach(s => {
      s.data.filter(f => f.label === 'Material').forEach(d => Materials.push(d.value));
    });
    let filters = [];
    let filterStr = '';

    filters = Materials.filter(f => f !== '').map(
      m => `Material eq '${m}' or substringof('${m}', Material) eq true`
    );
    filterStr = filters.join(' or ');
    return filterStr;
  };

  handleSearchFieldsSubmit = async () => {
    const { searchFields } = this.state;
    const filterStr = this.returnFilterSearch();
    const field = 'itemTableList';
    const sData = [];
    searchFields.forEach(s => sData.push(s.data));
    const nData = [];
    sData.forEach((s, i) => {
      s.forEach(m => {
        nData[i] = { ...nData[i], [m.label]: m.value };
      });
    });

    this.setState({ searchFieldsData: nData });

    if (filterStr !== '') {
      await this.props.getItemListData(
        0,
        this.props.enqueueSnackbar,
        () => {},
        filterStr,
        field,
        nData
      );
    } else {
      await this.props.getItemListData(0, this.props.enqueueSnackbar, () => {}, '', field, nData);
    }
  };

  handleSearchFieldsReset = () => {
    this.props.resetTableData();
    this.setState({ searchFields: [searchFieldItem], filteredData: [], page1: 0 });
  };

  returnIsFormValid = () => {
    const { searchFields } = this.state;
    let isFormValid = false;
    const sData = [];
    searchFields.forEach(s => sData.push(...s.data));
    isFormValid = sData.find(f => f.value === '') !== undefined;
    return isFormValid;
  };

  renderToggle = () => {
    const {
      rowsPerPage,
      page1,
      filteredData,
      filterField,
      searchTerm,
      showDateFilter,
      showMultiFilter,
      selectedDate,
      multiSelectData,
      selectedMaterial,
      selectedRows,
      searchFields,
    } = this.state;
    const { t, product, favourite } = this.props;
    const { listCount, itemTableList, isLoading } = product;
    const { favouriteItems, isFavourateIconLoading } = favourite;
    const columnsConfig = productColumnsConfig(
      t,
      this.handleAddToCartClick,
      this.handleFavourite,
      favouriteItems,
      isFavourateIconLoading,
      selectedMaterial,
      this.removeItemFromTable
    );
    // const isLast = index => index + 1 === searchFields.length;
    const isFormValid = this.returnIsFormValid();
    return (
      <Stack>
        {searchFields.map((s, index) => (
          <Grid>
            <Grid container flexDirection="row" justifyContent="space-between">
              <Grid
                item
                container
                flexDirection="row"
                alignItems="center"
                justifyContent={{ xs: 'center', sm: 'space-between' }}
                // spacing={6}
                // xs={8}
                // xs={12}
                sm={10}
              >
                {s.data.map(d => (
                  <Grid
                    item
                    container
                    flexDirection="row"
                    justifyContent={{ xs: 'center', md: 'flex-start' }}
                    alignItems="center"
                    xs={12}
                    sm={6}
                    md={6}
                    mt={{ xs: 1, sm: 0 }}
                  >
                    <Typography sx={{ fontSize: 12, mr: 1, fontWeight: 600 }}>
                      {d.label}
                      <span
                        style={{
                          color: 'red',
                          justifyContent: 'center',
                          fontSize: 12,
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <TextField
                      size="small"
                      placeholder={`Enter ${d.label}`}
                      value={d.value}
                      onChange={e => this.onChangeSearchFields(e, s, d.label)}
                      type={d.type}
                      classes={{ root: 'custom-root-4' }}
                    />
                  </Grid>
                ))}
              </Grid>
              <Grid
                xs={12}
                sm={2}
                container
                flexDirection="row"
                justifyContent={{ xs: 'center', sm: 'flex-end' }}
                alignItems="center"
              >
                <IconButton
                  onClick={() => this.handleAddSearchFields(index, s.id, 'remove')}
                  disabled={searchFields.length === 1}
                  // sx={{ mr: 2 }}
                >
                  <CloseOutlined color="error" fontSize="small" />
                </IconButton>

                <IconButton onClick={() => this.handleAddSearchFields(index, s.id)}>
                  <Add color="primary" fontSize="small" />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        ))}
        <Stack direction="row" justifyContent="center" spacing={2} my={2}>
          <Stack direction="row" justifyContent="center" spacing={2}>
            <LoadingButton
              // loadingPosition="start"
              loading={isLoading}
              // fullWidth
              variant="contained"
              disabled={isFormValid}
              onClick={this.handleSearchFieldsSubmit}
              sx={{
                height: 28,
              }}
            >
              Search
            </LoadingButton>
            {/* <IconButton onClick={this.handleSearchFieldsSubmit}>
                    <SearchOutlined color="primary" fontSize="small" />
                  </IconButton> */}
          </Stack>

          {/* {isLast(index) && ( */}
          <Stack direction="row" justifyContent="center" spacing={2}>
            <Button
              variant="contained"
              color="primary"
              // disabled={isFormValid}
              onClick={this.handleSearchFieldsReset}
              // sx={{
              //   fontSize: { xs: 10, sm: 12, md: 14 },
              // }}
              sx={{
                height: 28,
              }}
              size="small"
            >
              Reset
            </Button>
            {/* <IconButton onClick={this.handleSearchFieldsReset}>
                    <CachedOutlined color="primary" fontSize="small" />
                  </IconButton> */}
          </Stack>
        </Stack>

        {/* <Stack direction="row" justifyContent="flex-start" my={2}>
          <Button
            variant="contained"
            color="primary"
            disabled={selectedRows.length === 0}
            onClick={this.handleAddToCart}
            sx={{
              fontSize: { xs: 10, sm: 12, md: 14 },
              // mb: 2,
            }}
          >
            {t('uploadScreenTranslations:ADD_TO_CART')}
          </Button>
        </Stack> */}
        <ReactPlaceholder
          showLoadingAnimation
          ready={!isLoading}
          customPlaceholder={<TogglePlaceholder />}
        >
          <Table
            handleOnCellClick={this.handleItemClick}
            checkboxSelection
            onSelectionModelChange={s => {
              this.setState({ selectedRows: s });
            }}
            selectionModel={selectedRows}
            isRowSelectable={params =>
              params.row.col4 >= params.row.col10 && params.row.col4 > 0 && params.row.col6 > 0
            }
            columnsConfig={columnsConfig}
            favData={favouriteItems}
            data={itemTableList}
            showExport
            language={i18n.language}
            rowsPerPage={rowsPerPage}
            listCount={listCount}
            page={page1}
            onPageChange={this.handleChangeTog}
            saveFilterData={this.saveFilterData}
            filteredData={filteredData}
            loadFullData={this.loadToggleData}
            filterField={filterField}
            searchTerm={searchTerm}
            saveFilterFields={this.saveFilterFields}
            clearFilter={this.clearFilter}
            showDateFilter={showDateFilter}
            showMultiFilter={showMultiFilter}
            selectedDate={selectedDate}
            t={t}
            multiSelectData={multiSelectData}
            handleMultiSelection={this.handleMultiSelection}
            handleAddToCart={this.handleAddToCart}
            showAddToCart
            showVat
          />
        </ReactPlaceholder>
        {/* {failText !== '' && (
          <Typography sx={styles.failText} textAlign="center">
            {failText}
          </Typography>
        )} */}
        {/* <Typography sx={styles.failText} textAlign="center">
          {t('productScreenTranslations:NO_PRODS_FOUND')}
        </Typography> */}
      </Stack>
    );
  };

  render() {
    const { isLoading, isMaterialLoading, listCount, failText, itemList } = this.props.product;

    const { t } = this.props;
    const {
      sortOrder,
      searchTerm,
      searchSubmitted,
      filterConfigData,
      searchKey,
      viewMode,
      page,
    } = this.state;
    const count = this.returnCount(itemList);
    const term = searchKey.substring(0, 20);
    const sk = searchKey.length > 20 ? `${term}...` : searchKey;

    const showClear =
      filterConfigData[0].config.data.length > 0
        ? filterConfigData[0].config.data.some(s => s.checked)
        : false;
    return (
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
          <Breadcrumb
            {...this.props}
            breadcrumbNameMap={breadcrumbNameMap(t)}
            showDivider={false}
          />

          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={this.handleViewModeChange}
            aria-label="view mode"
            sx={{ my: 2, cursor: 'pointer' }}
          >
            <ToggleButton value="details" sx={{ cursor: 'pointer' }}>
              <ViewModuleIcon style={{ width: 14, height: 14 }} />
            </ToggleButton>
            <ToggleButton value="list" sx={{ cursor: 'pointer' }}>
              <ListIcon style={{ width: 16, height: 16 }} />
            </ToggleButton>
          </ToggleButtonGroup>
        </Stack>
        <Divider />
        {viewMode === 'list' ? (
          <Grid container direction="row" justifyContent="space-between" sx={{ marginY: 6 }}>
            <ReactPlaceholder
              showLoadingAnimation
              ready={filterConfigData[0].config.data.length > 0 && !isMaterialLoading}
              customPlaceholder={<FilterPlaceholder />}
            >
              <Filter
                saveFilter={data => this.saveFilter(data)}
                clearFilter={this.clearFilterComponent}
                filterConfig={filterConfigData}
                t={this.props.t}
                isProductsLoading={isLoading}
                disableClear={!showClear}
              />
            </ReactPlaceholder>

            <Grid item xs={12} sm={12} md={8}>
              <TextField
                fullWidth
                placeholder={t('productScreenTranslations:SEARCH')}
                id="fullWidth"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {searchTerm !== '' ? (
                        <IconButton aria-label="clear" onClick={this.resetSearchFilter}>
                          <CloseOutlined sx={{ fontSize: 16 }} />
                        </IconButton>
                      ) : null}
                      <IconButton aria-label="search" onClick={this.handleSearchSubmit}>
                        <SearchOutlined />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                value={searchTerm}
                onChange={this.onChangeSearchInput}
                onKeyPress={this.onSearchKeyPress}
              />

              <Stack
                direction="row"
                justifyContent="space-between"
                container
                spacing={1}
                alignItems="center"
                sx={{ mt: 4, mb: 4 }}
              >
                {searchSubmitted && sk !== '' && !isLoading ? (
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography>
                      {`${t('productScreenTranslations:SHOWING')} ${
                        itemList.length > 0 ? itemList.length : t('productScreenTranslations:NO')
                      }
                     ${t('productScreenTranslations:RESULTS_FOR')} `}
                    </Typography>
                    <Chip label={sk} variant="outlined" onDelete={this.resetSearchFilter} />
                  </Stack>
                ) : null}
                {!isLoading && !searchSubmitted && sk === '' ? (
                  <Stack alignSelf="flex-end">
                    <Typography>
                      {`${t('productScreenTranslations:SHOWING')} ${itemList.length}
                     ${t('productScreenTranslations:RESULTS')} `}
                    </Typography>
                  </Stack>
                ) : null}
              </Stack>

              <Grid container direction="row" justifyContent="space-between" sx={{ mt: 4 }}>
                <Grid item xs={12} sm={6} md={6} lg={3}>
                  <FormControl fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      sx={{ fontSize: { xs: 12, sm: 14, md: 14 } }}
                    >
                      {t('productScreenTranslations:SORT_BY')}
                    </InputLabel>
                    <Select
                      fullWidth
                      value={sortOrder}
                      label="Sort By"
                      onChange={this.onChangeSortBySelectInput}
                      sx={{ fontSize: { xs: 12, sm: 14, md: 14 } }}
                    >
                      <MenuItem
                        value="Low - High Price"
                        sx={{ fontSize: { xs: 12, sm: 14, md: 14 } }}
                      >
                        {t('productScreenTranslations:LOW_TO_HIGH_PRICE')}
                      </MenuItem>
                      <MenuItem
                        value="High - Low Price"
                        sx={{ fontSize: { xs: 12, sm: 14, md: 14 } }}
                      >
                        {t('productScreenTranslations:HIGH_TO_LOW_PRICE')}
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item>
                  <Stack direction="row" sx={{ mt: { xs: 2, sm: 0 } }} alignItems="center">
                    <Typography
                      style={{ color: COLOR.helperTextColor, fontSize: 13 }}
                      sx={{ mr: { xs: 2, sm: 2, md: 2 } }}
                    >
                      {count > 0 ? (
                        <>
                          {t('productScreenTranslations:SELECTED')}
                          <span style={{ color: 'black' }}>
                            {` ${count} ${
                              count > 1
                                ? t('productScreenTranslations:ITEMS')
                                : t('productScreenTranslations:ITEM')
                            }`}
                          </span>
                        </>
                      ) : (
                        ''
                      )}
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{
                        opacity: count <= 0 ? 0.5 : 1,
                      }}
                      sx={{
                        fontSize: { xs: 10, sm: 12, md: 14 },
                      }}
                      onClick={this.handleAddMultipleItemToCart}
                      disabled={count <= 0}
                    >
                      {t('productScreenTranslations:ADD_ALL_CART')}
                    </Button>
                  </Stack>
                </Grid>
              </Grid>

              <ReactPlaceholder
                showLoadingAnimation
                ready={!isLoading}
                customPlaceholder={<ListPlaceholder />}
              >
                <>
                  {this.renderList(itemList)}
                  {itemList.length > 0 ? (
                    <Stack direction="row" justifyContent="center" sx={{ mt: 10 }}>
                      <Pagination
                        count={Math.ceil(listCount / 20)}
                        shape="rounded"
                        page={page}
                        onChange={this.handleChange}
                        color="primary"
                      />
                    </Stack>
                  ) : null}
                </>
              </ReactPlaceholder>

              {searchSubmitted && searchKey !== '' && itemList.length === 0 && !isLoading ? (
                <Typography
                  sx={{ m: 4, fontSize: 36, color: COLOR.helperTextColor }}
                  textAlign="center"
                  position="absolute"
                  top="50%"
                  left="50%"
                  transform="translate(-50%, -50%)"
                >
                  {`${t('productScreenTranslations:NO_RESULTS_FOR')} "${term}"`}
                </Typography>
              ) : null}
              {failText !== '' &&
              !isMaterialLoading &&
              itemList.length === 0 &&
              !isLoading &&
              searchKey === '' ? (
                <Typography
                  sx={{ m: 4, fontSize: 36, color: COLOR.helperTextColor }}
                  textAlign="center"
                >
                  {failText}
                </Typography>
              ) : null}
            </Grid>
          </Grid>
        ) : (
          <Box sx={styles.tableContainer}>{this.renderToggle()}</Box>
        )}
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    cart: state.cart,
    product: state.product,
    favourite: state.favourite,
    auth: state.auth,
  };
};

const cProducts = connect(mapStateToProps, {
  addToCart,
  addMultipleItemToCart,
  getItemListData,
  addToFavorite,
  removeFavouriteItem,
  getFavouriteData,
  getMaterialGroupTableData,
  addRemoveFavourites,
  saveItemList,
  // getAllProductsData,
  resetTableData,
  updateTableData,
})(Products);

const tProducts = withTranslation(['productScreenTranslations'])(cProducts);
const sProducts = withSnackbar(tProducts);

export { sProducts as Products };
